import { createEmployer, editEmployer, getEmployers } from '../api';
import { dispatchErrorAction } from './index';
import { getPagesCount } from '../helpers/general';
import { USERS_LIST_PAGE_SIZE } from '../constants/general';
import { GET_ALL_EMPLOYERS_SUCCESS, CLEAR_EMPLOYER_DETAILS, GET_EMPLOYER_DETAILS_SUCCESS } from './actionTypes';

export function getAllEmployers (skip = 0, filterData) {
  return dispatch => getEmployers(skip, filterData)
    .then(({ data }) => {
      const pagesQuantity = getPagesCount(data.count, USERS_LIST_PAGE_SIZE);
      dispatch({ type: GET_ALL_EMPLOYERS_SUCCESS, employersList: data.data, pagesQuantity });
      return { data: data.data, pagesQuantity };
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearEmployerDetails () {
  return dispatch => dispatch({ type: CLEAR_EMPLOYER_DETAILS });
}

export function createNewEmployer (payload) {
  return dispatch => createEmployer(payload)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function editEmployerUser (id, payload) {
  return dispatch => editEmployer(id, payload)
    .then(({ data }) => dispatch({ type: GET_EMPLOYER_DETAILS_SUCCESS, payload: data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/employers.js